{
  "name": "staff-journey-planner",
  "version": "0.3.81-beta",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start:mock": "ng serve --configuration mock",
    "build": "node build.js",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "pretty-quick": "pretty-quick --staged",
    "prepare": "husky",
    "lint": "ng lint"
  },
  "prettier": {
    "printWidth": 100,
    "singleQuote": true,
    "overrides": [
      {
        "files": "*.html",
        "options": {
          "parser": "angular"
        }
      }
    ]
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.17",
    "@angular/common": "^21.1.0",
    "@angular/compiler": "^21.1.0",
    "@angular/core": "^21.1.0",
    "@angular/forms": "^21.1.0",
    "@angular/localize": "^21.2.17",
    "@angular/material": "~21.1.5",
    "@angular/platform-browser": "^21.1.0",
    "@angular/router": "^21.1.0",
    "@fontsource/material-symbols-outlined": "^5.1.4",
    "date-fns": "^4.4.0",
    "material-symbols": "^0.31.1",
    "oidc-client-ts": "^3.5.0",
    "rxjs": "~7.8.0",
    "tslib": "^2.8.1"
  },
  "devDependencies": {
    "@angular/build": "^21.1.4",
    "@angular/cli": "^21.1.4",
    "@angular/compiler-cli": "^21.1.0",
    "@eslint/js": "^9.39.2",
    "@types/jasmine": "~5.1.0",
    "@typescript-eslint/eslint-plugin": "^8.56.0",
    "@typescript-eslint/parser": "^8.56.0",
    "angular-eslint": "21.3.1",
    "eslint": "^9.39.2",
    "husky": "^9.1.7",
    "jasmine-core": "~5.9.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "lint-staged": "^15.2.10",
    "prettier": "3.4.2",
    "prettier-plugin-organize-attributes": "^1.0.0",
    "pretty-quick": "^4.2.2",
    "typescript": "~5.9.2",
    "typescript-eslint": "8.40.0"
  },
  "lint-staged": {
    "*.{js,ts,html}": [
      "eslint --cache --quiet --fix"
    ]
  }
}
